import React from 'react';
import { Router } from '@reach/router';
import TokenCheck from './TokenCheck';
import Dashboard from '../../Dashboard';
import Pack from '../../Pack';
import Book from '../../Book';
import Class from '../../Class';
import CreateTask from '../../Task/scenes/CreateTask';
import Task from '../../Task';
import Promo from '../../Promo';
import StartWrite from '../../Writes/scenes/StartWrite';

const AppRouter = () => {
    return (
        <Router>
            <TokenCheck path='/'>
                <Dashboard path='/' default/>
                <Book path='/book/:classBookId' />
                <Pack path='/pack/:classPackId' />
                <Class path='/class/:classId'/>
                <StartWrite path='/startWrite/*' />
                <CreateTask path='/task/new/:classId' />
                <Task path='/task/:classBookId' />
                <Promo path='/promo/:promoId' />
                <Promo path='/promo/:promoId/impersonate' />
            </TokenCheck>
        </Router>
    )
}

export default AppRouter;